import { LogType } from './logbuffer';
import Logger, { LogLevel } from './logger';
import LogReporter from './logreporter';
import ReduxLogger from './reduxLogger';
import TapLogger from './tapLogger';
import titleFormatter from './titleFormatter';
const loggerSwitcher = [
    LogLevel.DEBUG,
    LogLevel.INFO,
    LogLevel.WARN,
    LogLevel.ERROR
];
let logLevelIndex = 1;
function createLogger(customOption = {}) {
    const options = {
        titleFormatter,
        ...customOption
    };
    Logger.configure(options);
    LogReporter.configure(options.http);
    if (options.level) {
        logLevelIndex = loggerSwitcher.indexOf(options.level);
    } else {
        logLevelIndex = loggerSwitcher.indexOf(LogLevel.INFO);
    }
    window.onkeydown = (evt)=>{
        if (!evt) evt = event;
        if (evt.ctrlKey && evt.shiftKey && evt.keyCode === 76) {
            logLevelIndex = logLevelIndex + 1 > 3 ? 0 : logLevelIndex + 1;
            Logger.setLogLevel(loggerSwitcher[logLevelIndex]);
        }
    };
    return ReduxLogger(options);
}
export { ReduxLogger };
export { Logger };
export { LogLevel };
export { LogType };
export { TapLogger };
export default createLogger;
